import { getCoordinates as _getCoordinates } from "./common";

export const getCoordinates = async () => {
  return await _getCoordinates(navigator && navigator.geolocation);
};
